const DatepickerOptions = {
    buttonClass: 'btn',
    calendarWeeks: true,
    format: {
        toValue(date, format, locale) {
            let dateObject;
            //...your custom parse logic
            return dateObject;
        },
        toDisplay(date, format, locale) {
            let dateString;
            //...your custom format logic
            return dateString;
        },
    },
    language: 'da',
    nextArrow: '<i class="fal fa-chevron-right"></i>',
    prevArrow: '<i class="fal fa-chevron-left"></i>',
    todayHighlight: true,
    //todayBtn: true,
}

export default DatepickerOptions